exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".field{text-align:left;display:inline-block;border:1px solid #333;vertical-align:top;margin-bottom:20px;margin-right:20px;border-radius:5px;box-shadow:2px 2px 6px rgba(0,0,0,.6)}.field h2{background:#fff;margin:0;padding:3px 8px;border-radius:5px}.card{display:inline-block}.field ul{margin:0;padding:0;list-style-type:none}.field li{text-align:left;margin-bottom:4px}.card li a{margin-right:5px}.card li a:last-child{margin-right:0}a.old{color:blue;font-weight:700}.submit-actions{margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5fc46064","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/EditConfig.vue
// module id = 185
// module chunks = 0